<img src="/img/favicon.svg" class="img-anim" width="100" height="100">
<h1>404 Not Found</h1>
